import { getIn, useFormikContext } from "formik"
import * as Yup from 'yup'

import { FormikInspectorAgreeCheck, FormikNotesArea } from "../../../../../../components/widgets"
import { useEffect } from "react"
import { IWebFileAttachment } from "../../../../../core/applications"

// Site Inspection
export interface IDLMPhaseNote  {
  verdict: string
  workflow: string
  note: string
  noteAttachments: Array<IWebFileAttachment>
  inspectorAgree: boolean
}

export const initDLMPhaseNoteValues = {
  verdict: '',
  workflow: '',
  note: '',
  noteAttachments: [],
  inspectorAgree: false,
}


const InspectorAgreeStates = [
  'Site Inspection Review'
]

export const DLMPhaseNoteSchema: any = Yup.object({
  appState: Yup.string().trim(),
  verdict: Yup.string().trim(),
  workflow: Yup.string().trim(),
  note: Yup.string().trim().label('Note')
  .when('verdict', {
    is : (verdict: string) => (verdict !== 'approved'),
    then: (schema) => schema.required(),
  }),
  inspectorAgree: Yup.bool().label('Confirmation')
  .when(['appState', 'verdict'], {
    is : (appState: string, verdict: string) => (InspectorAgreeStates.includes(appState) && verdict === 'approved'),
    then: (schema) => schema.oneOf([true], 'Must be checked'),
  }),
  noteAttachments: Yup.array(),

});

export const DLMPhaseNoteForm = () => {

  const { values, validateField } = useFormikContext();


  const verdict = getIn(values, 'verdict') ?? '';
  const appState = getIn(values, 'appState') ?? '';
    
  useEffect(() => {    
    validateField('note');
    validateField('inspectorAgree');        
  }, [verdict, validateField]);
    

  return (
  <>
  <FormikNotesArea required={(verdict !== 'approved')} />
  { (InspectorAgreeStates.includes(appState) && verdict === 'approved') &&
  <FormikInspectorAgreeCheck />
  }
  </>
  )
}